import { useState } from "react";
import { motion } from "framer-motion";
import { LOOP_STAGES } from "@/data/site";

// Understand → Think → Decide → Execute → Learn
// Horizontal on desktop, vertical on mobile. Interactive on hover/focus/click.
export function SystemLoop() {
  const [active, setActive] = useState(0);

  return (
    <div data-testid="system-loop">
      {/* Desktop */}
      <div className="hidden md:flex items-stretch gap-4">
        {LOOP_STAGES.map((s, i) => (
          <div key={s.key} className="flex-1 flex items-stretch">
            <button
              onMouseEnter={() => setActive(i)}
              onFocus={() => setActive(i)}
              onClick={() => setActive(i)}
              data-testid={`loop-stage-${s.key}`}
              className={`relative w-full text-left rounded-2xl p-6 transition-all duration-500 ${active === i ? "glass-heavy border-hairline/20" : "glass-medium hover:border-hairline/12"}`}
            >
              <span className="text-xs font-mono text-subtle">0{i + 1}</span>
              <h3 className="display text-2xl font-medium text-ink mt-3">{s.title}</h3>
              <motion.p
                initial={false}
                animate={{ opacity: active === i ? 1 : 0.4 }}
                className="text-sm text-subtle mt-2 leading-relaxed"
              >
                {s.text}
              </motion.p>
              {active === i && (
                <motion.span layoutId="loop-underline" className="absolute left-6 right-6 bottom-4 h-px bg-oraya-accent" />
              )}
            </button>
          </div>
        ))}
      </div>

      {/* Mobile vertical flow */}
      <div className="md:hidden flex flex-col gap-3">
        {LOOP_STAGES.map((s, i) => (
          <div key={s.key} className="relative">
            <button
              onClick={() => setActive(i)}
              data-testid={`loop-stage-mobile-${s.key}`}
              className={`w-full text-left rounded-2xl p-5 transition-all duration-300 ${active === i ? "glass-heavy border-hairline/20" : "glass-medium"}`}
            >
              <div className="flex items-center gap-3">
                <span className="text-xs font-mono text-subtle">0{i + 1}</span>
                <h3 className="display text-xl font-medium text-ink">{s.title}</h3>
              </div>
              {active === i && <p className="text-sm text-subtle mt-2">{s.text}</p>}
            </button>
            {i < LOOP_STAGES.length - 1 && <div className="mx-auto w-px h-4 bg-hairline/10" />}
          </div>
        ))}
      </div>
    </div>
  );
}
